<template>
    <div>
        <report-header
            :title="title"
            :isShowDateRange="true"
            :formatDateRangeTitle="dateRange"
        />
        <b-card>
            <div v-if="!loaded">
                <img src="assets/ajax-loader.gif" style="padding: 10px;" />
            </div>
            <div id="report-body" v-if="loaded" class="w-100">
                <div v-if="result && result.length > 0">
                    <b-table-simple bordered>
                        <b-thead head-variant="dark">
                            <b-tr>
                                <b-th>Date</b-th>
                                <b-th>Recipient</b-th>
                                <b-th>Email</b-th>
                                <b-th>Status</b-th>
                                <b-th>Type</b-th>
                                <b-th>Subject</b-th>
                            </b-tr>
                        </b-thead>
                        <b-tbody>
                            <b-tr :key="data.id" v-for="data in result">
                                <b-td> {{ formatDate(data.create_at) }} </b-td>
                                <b-td v-if="!data.contact_encoded_id">
                                    <router-link
                                        v-if="USE_CLIENT_MODULE_VUE"
                                        :to="`/client/profile/${data.actor_id}?encoded=0`"
                                    >
                                        {{ formatClientName(data) }}
                                    </router-link>
                                    <a v-else :href="getClientURI(data)">
                                        {{ formatClientName(data) }}
                                    </a>
                                </b-td>
                                <b-td
                                    v-else
                                    v-html="formatContactDetails(data)"
                                ></b-td>
                                <b-td> {{ data.email }} </b-td>
                                <b-td> {{ data.communication_status }} </b-td>
                                <b-td> {{ data.bounce_type }} </b-td>
                                <b-td> {{ getSubject(data) }} </b-td>
                            </b-tr>
                        </b-tbody>
                    </b-table-simple>
                </div>
                <div v-else>
                    <i>No records available</i>
                </div>
            </div>
        </b-card>
    </div>
</template>
<script>
import Report from "@/mixins/report";
export default {
    components: {
        ReportHeader: () => import("@/components/report/report-header")
    },
    mixins: [Report],
    props: {
        data: {
            type: Object,
            default() {
                return {
                    start: moment(),
                    end: moment()
                };
            }
        }
    },
    data() {
        return {
            locale: "en-US",
            loaded: false,
            meta: "",
            result: [],
            tableHeader: [],
            dateRange: "",
            title: "Failed Emails",
            code: "",
            params: "",
            refresh: 0,
            USE_CLIENT_MODULE_VUE: process.env.USE_CLIENT_MODULE_VUE === "true",
            currentExpandedCommId: null
        };
    },
    mounted() {
        let self = this;
        // --- toggle navigation options
        self.data.isShowDateRange = true;

        self._getSetting().then(() => {
            self.data.start = moment().tz(self._timeZone).startOf("week");
            self.data.end = moment().tz(self._timeZone).endOf("day");
            self.data.from = moment().tz(self._timeZone).startOf("week").unix();
            self.data.to = moment().tz(self._timeZone).endOf("day").unix();
            self.init();
        });

        self.$root.$on("report-filter-date-range:refresh", self.init);
        self.$root.$on("failed-emails:refresh", function () {
            self.refresh = 1;
            self.init();
        });

        window.scrollTo(0, 0);
    },
    beforeDestroy: function () {
        this.$root.$off("report-filter-date-range:refresh", this.init);
    },
    methods: {
        init(params) {
            let self = this;
            self.loaded = false;

            if (params) {
                self.data.from = params.from;
                self.data.to = params.to;
                self.refresh = params.refresh;
            }
            self.$http
                .get(
                    process.env.BARRAMUNDI +
                        "report/reports/91?from=" +
                        self.data.from +
                        "&to=" +
                        self.data.to +
                        "&refresh=" +
                        self.refresh
                )
                .then(response => {
                    if (response) {
                        const res = response.data;

                        self.result = res.response.resource.results;
                        self.tableHeader = res.response.resource.header;
                        self.title = res.response.resource.meta.title;
                        self.dynamicPageTitle(self.title);
                        self.dateRange =
                            " (" +
                            moment
                                .unix(res.response.resource.meta.from)
                                .tz(self._timeZone)
                                .format(self.getDateFormat()) +
                            " - " +
                            moment
                                .unix(res.response.resource.meta.to)
                                .tz(self._timeZone)
                                .format(self.getDateFormat()) +
                            ")";
                        self.loaded = true;
                    }
                });
        },
        getClientURI(data) {
            if (data.recipient_isactive) {
                return (
                    process.env.CI_APPS +
                    "client/client/view/" +
                    data.actor_id +
                    "/0"
                );
            }

            return false;
        },
        formatClientName(data) {
            if (data.recipient_isactive) {
                return data.firstname + " " + data.lastname;
            } else {
                return data.firstname + " " + data.lastname + " (deleted)";
            }
        },
        formatContactDetails(data) {
            var withData = "";

            switch (data.communication_contact_type) {
                case 1:
                case "1":
                    withData =
                        '<a href="' +
                        process.env.CI_APPS +
                        "contact/company/view/" +
                        data.contact_encoded_id +
                        '">' +
                        data.contact_business_name +
                        "</a>";
                    break;
                default:
                    withData =
                        '<a href="' +
                        process.env.CI_APPS +
                        "contact/contact/view/" +
                        data.contact_encoded_id +
                        '">' +
                        data.firstname +
                        " " +
                        data.lastname +
                        "</a>";
                    break;
            }

            return withData;
        },
        formatDate(date) {
            return moment
                .unix(date)
                .tz(this._timeZone)
                .format(this.getDateFormat());
        },
        getSubject(data) {
            let subject = "--";
            if (data.note) {
                subject = data.note;
            }

            if (data.communication_subject) {
                subject = data.communication_subject;
            }

            return subject;
        }
    }
};
</script>
<style>
.total {
    font-weight: bold;
}
</style>
